import { useAuth } from "../auth";
import { Button } from "@/components/ui/button";
import { 
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel } from "@/components/ui/form"
import { Input } from "@/components/ui/input";
import { useForm } from "react-hook-form"
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { useState } from "react";
import { UserSchema } from "@/components/user/UserSchema";
import { useTranslate } from "@/helper/translate";
import Icon from '@/img/logo_rm.svg';
export function LoginPage()
{

    const { translate } = useTranslate();
  
  const { login } = useAuth();
    const [errorText, setError] = useState("");
  
  const form = useForm<z.infer<typeof UserSchema>>({
    resolver: zodResolver(UserSchema)
  });

  const onSubmit = async(values: z.infer<typeof UserSchema>) => {
 

    try {
          setError("");
          
           await login(form.getValues("UserName")??"", form.getValues("Password")??"")

        } catch (err) {
          setError((err as Error).message);
        }
  }

  return (
    <div className="w-1/3 p-5 ml-auto mr-auto mt-20">

      <h1 className="text-7xl text-center font-bold p-2 mb-10  flex justify-center"><img src={Icon}/></h1>
      <Form {...form}>
           <form onSubmit={form.handleSubmit(onSubmit, (error) => { console.log("Validation errors:", error); })} className="space-y-2">
          <FormField
            control={form.control}
            name="UserName"
            render={({ field }) => (
              <FormItem>
                <FormLabel>{translate("auth.email")}</FormLabel>
                <FormControl>
                  <Input {...field} />
                </FormControl>
              </FormItem>
            )}
          />
          <FormField
            control={form.control}
            name="Password"
            render={({ field }) => (
              <FormItem>
                <FormLabel>{translate("auth.pwd")}</FormLabel>
                <FormControl>
                  <Input {...field} />
                </FormControl>
              </FormItem>
            )}
          />

          {errorText && <div className="text-red-500">{errorText}</div>}
          <Button className="w-full" type="submit">{translate("auth.login")}</Button>
        </form>
      </Form>
    </div>
    
  )
}